<ion-content>
  <div style="display: flex; flex-direction: column; height: 100vh; width: 100vw;">
  
    <div class="ds-accounts-body">

      <div class="ds-accounts-body-plans">
        <!-- Use *ngFor to loop through pricingCards array -->
        <div class="ds-card-pricing">
          <div class="ds-card-pricing-title">
            {{ selectedPlan.title }}
          </div>
          <div class="ds-card-pricing-price">
            <span class="price-symbol">€</span>
            <span class="price-amount">{{ selectedPlan.price }}</span>
            <span class="price-period">/ {{ 'MONTHLY' | translate }}</span> <!-- Assuming all are monthly plans -->
          </div>

          <hr>

          <div class="ds-card-pricing-features">
            <!-- Loop through each card's features -->
            <div class="ds-card-pricing-features-item" *ngFor="let feature of selectedPlan.features">
              <ion-icon name="checkmark-circle"></ion-icon>
              <span>{{ feature?.text }}</span>
            </div>
          </div>
        </div>
      </div>



      <div class="ds-accounts-body-box ds-accounts-body-payment">

        <ng-container *ngIf="!itAlreadyHasUserData">
        
            <div class="ds-accounts-body-box-title">
                {{"IMPROVE_PLAN" | translate}} {{ selectedPlan.title }}
            </div>

            <div class="ds-accounts-body-box-subtitle">
                {{"PLEASE_FILL_IN_YOUR_BILLING_DETAILS" | translate}}
            </div>

        <form [formGroup]="userForm" class="ds-accounts-body-box-form">
            <!-- Email Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    Email
                </div>
                <div class="ds-input-primary-content">
                    <input type="email" placeholder="email@example.com" label="Correo electrónico" label-placement="stacked" formControlName="email">
                    <div *ngIf="errorControl['email']?.invalid && (errorControl['email']?.dirty || errorControl['email']?.touched)" class="error-message">
                        <span *ngIf="errorControl['email']?.errors?.['required']">{{"EMAIL_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['email']?.errors?.['email']"> {{"EMAIL_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- Name Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    {{"FULL_NAME" | translate}}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Full name" formControlName="name">
                    <div *ngIf="errorControl['name']?.invalid && (errorControl['name']?.dirty || errorControl['name']?.touched)" class="error-message">
                        <span *ngIf="errorControl['name']?.errors?.['required']">{{"NAME_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['name']?.errors?.['minlength'] || errorControl['name']?.errors?.['maxlength']">{{"NAME_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- Add similar error message blocks for the remaining fields -->
            <!-- For demonstration, I'll add it for the phone field as well -->

            <!-- Phone Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    
                    {{"PHONE" | translate}}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Phone number" formControlName="phone">
                    <div *ngIf="errorControl['phone']?.invalid && (errorControl['phone']?.dirty || errorControl['phone']?.touched)" class="error-message">
                        <span *ngIf="errorControl['phone']?.errors?.['required']">{{"PHONE_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['phone']?.errors?.['pattern']">{{"PHONE_INVALID" | translate}}</span>
                        <span *ngIf="errorControl['phone']?.errors?.['minlength'] || errorControl['phone']?.errors?.['maxlength']">{{"PHONE_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- NIF/CIF Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    {{"NIF_OR_CIF" | translate}}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce the company or personal ID" formControlName="nif">
                    <div *ngIf="errorControl['nif']?.invalid && (errorControl['nif']?.dirty || errorControl['nif']?.touched)" class="error-message">
                        <span *ngIf="errorControl['nif']?.errors?.['required']">{{"NIF_OR_CIF_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['nif']?.errors?.['minlength'] || errorControl['nif']?.errors?.['maxlength']">{{"NIF_OR_CIF_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- Company Name Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    {{"COMPANY_NAME_OR_PERSONAL_NAME" | translate}}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce the name of your company" formControlName="companyName">
                    <div *ngIf="errorControl['companyName']?.invalid && (errorControl['companyName']?.dirty || errorControl['companyName']?.touched)" class="error-message">
                        <span *ngIf="errorControl['companyName']?.errors?.['required']">{{"COMPANY_NAME_OR_PERSONAL_NAME_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['companyName']?.errors?.['minlength'] || errorControl['companyName']?.errors?.['maxlength']">{{"COMPANY_NAME_OR_PERSONAL_NAME_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- Country Field -->
            <!-- Country Field -->
            <div class="ds-input-primary" #triggerInput>
                <div class="ds-input-primary-label">
                     {{ "COUNTRY" | translate }}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce the name of your country" formControlName="country" (click)="onExtensionSelectorClick($event)" (input)="setSearchTerm($event)" id="countryInput">
                    <div *ngIf="errorControl['country']?.invalid && (errorControl['country']?.dirty || errorControl['country']?.touched)" class="error-message">
                        <span *ngIf="errorControl['address']?.errors?.['required']">{{"COUNTRY_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['country']?.errors?.['minlength'] || errorControl['country']?.errors?.['maxlength']">{{"COUNTRY_LENGTH_INVALID" | translate}}</span>
                        <span *ngIf="errorControl['country']?.errors?.['invalidCountryName']">{{"COUNTRY_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- City Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                     {{ "CITY" | translate }}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce your city" formControlName="city">
                    <div *ngIf="errorControl['city']?.invalid && (errorControl['city']?.dirty || errorControl['city']?.touched)" class="error-message">
                        <span *ngIf="errorControl['address']?.errors?.['required']">{{"CITY_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['city']?.errors?.['minlength'] || errorControl['city']?.errors?.['maxlength']">{{"CITY_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

             <!-- CP Field -->
             <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    {{ "POSTAL_CODE" | translate }}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce your postal code" formControlName="cp">
                    <div *ngIf="errorControl['cp']?.invalid && (errorControl['cp']?.dirty || errorControl['cp']?.touched)" class="error-message">
                        <span *ngIf="errorControl['address']?.errors?.['required']">{{"CP_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['cp']?.errors?.['minlength'] || errorControl['cp']?.errors?.['maxlength']">{{"CP_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>

            <!-- Address Field -->
            <div class="ds-input-primary">
                <div class="ds-input-primary-label">
                    {{ "ADDRESS" | translate }}
                </div>
                <div class="ds-input-primary-content">
                    <input type="text" placeholder="Introduce your address" formControlName="address">
                    <div *ngIf="errorControl['address']?.invalid && (errorControl['address']?.dirty || errorControl['address']?.touched)" class="error-message">
                        <span *ngIf="errorControl['address']?.errors?.['required']">{{"ADDRESS_REQUIRED" | translate}}</span>
                        <span *ngIf="errorControl['address']?.errors?.['minlength'] || errorControl['address']?.errors?.['maxlength']">{{"ADDRESS_LENGTH_INVALID" | translate}}</span>
                    </div>
                </div>
            </div>
            <br>
            <div class="ds-accounts-body-box-form-button">
                <button class="ds-button-primary" type="submit" [disabled]="!this.userForm.valid" (click)="onSubmit()">{{"SAVE_DATA" | translate}}</button>
            </div>
        </form>
        
        </ng-container>


        <ng-container *ngIf="itAlreadyHasUserData">
          <ng-container  *ngIf="!userCard">
            <div class="ds-accounts-body-box-title">
              {{ "INTRODUCE_PAYMENT_METHOD" | translate }}
            </div>
    
            <div class="ds-accounts-body-box-subtitle">
                {{ "NO_CHARGE_VERIFY_CARD" | translate }}
            </div>
    
            <app-stripe-card [noText]="true" (uploadCardFinish)="uploadCardFinish()"></app-stripe-card>
    
          </ng-container>
  
          <ng-container *ngIf="userCard">
            <app-stripe-subscription></app-stripe-subscription>

            
            <ng-container  *ngIf="userData?.totalumInstances?.[0]?.plan !== selectedPlan?.id">
                <div class="ds-text">
                    {{ "CLICK_CHOOSE_PLAN" | translate }}
                </div>
                <div style="display: flex; justify-content: center;">
                    
    
                    <button class="ds-button-tertiary" (click)="onUpgradePlan()" [disabled]="upgradingPlan">
                        <ng-container *ngIf="upgradingPlan">
                            <ion-spinner></ion-spinner>{{ "UPDATING_PLAN" | translate }}
                        </ng-container>
                        <ng-container *ngIf="!upgradingPlan">
                            <ion-icon name="checkmark-outline"></ion-icon>{{ "CHOOSE_PLAN" | translate }}
                        </ng-container>
                    </button>
                </div>
            </ng-container>
            

            <div style="display: flex; justify-content: center;" *ngIf="userData?.totalumInstances?.[0]?.plan === selectedPlan?.id">
                <button class="ds-button-tertiary"  [disabled]="true">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    {{"CURRENT_PLAN" | translate }}
                </button>
            </div>
          </ng-container>
        </ng-container>


      </div>
    </div>
  </div>
  
</ion-content>

<div #tooltip class="custom-tooltip" id="customTooltip" *ngIf="tooltipVisible" [ngStyle]="{'top': tooltipPosition.top, 'left': tooltipPosition.left, 'width': tooltipPosition.width}">
    <app-modal-country-selector (onSelect)="onSelectCountry($event)" [searchTerm]="searchTerm"></app-modal-country-selector>
  </div>
    
